import { create } from 'zustand';
import { IDeliveryType } from './types';

interface DeliveryTypeState {
  deliveryType: IDeliveryType | null;
  setDeliveryType: (type: IDeliveryType) => void;
}

export const useDeliveryTypeStore = create<DeliveryTypeState>()((set) => ({
  deliveryType: null,
  setDeliveryType: (type) => set({ deliveryType: type }),
}));
